import axios from '@/jslib/axios'

export const getStatisticsList= params => {
  return axios({
    method: 'get',
    url: '/admin/statistics/list',
    params
  })
}
export const getTicketStatisticsList= params => {
  return axios({
    method: 'get',
    url: '/admin/ticket/statistics/list',
    params
  })
}
export const getStatisticsDownload = params => {
  return axios({
    method: 'get',
    url: '/admin/export/statistics',
    responseType: 'blob',
    params,
    timeout: 120000
  })
}
export const getReportDownload = params => {
  return axios({
    method: 'get',
    url: '/admin/ticket/statistics/export',
    responseType: 'blob',
    params,
    timeout: 120000
  })
}
